import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TimelineConnector, TimelineContent, TimelineItem, TimelineOppositeContent, TimelineSeparator, } from '@mui/lab';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { TimelineDot } from './TimelineDot.js';
import { TimelineEventCard } from './TimelineEventCard.js';
export function TimelineEventItem(props) {
    const { event, selectedEventId, onSelectionChange, showConnector = true } = props;
    const isSelected = event.id === selectedEventId;
    const toggleSelection = React.useCallback(() => {
        onSelectionChange(isSelected ? undefined : event.id);
    }, [isSelected, event.id, onSelectionChange]);
    return (_jsxs(TimelineItem, { children: [_jsx(TimelineOppositeContent, { children: _jsx(Box, { sx: { width: 0 } }) }), _jsxs(TimelineSeparator, { children: [_jsxs(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                        }, children: [_jsx(Box, { sx: {
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                }, children: _jsx(TimelineDot, { event: event, isSelected: isSelected, onClick: toggleSelection }) }), _jsx(Box, { sx: {
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                }, children: _jsx(Typography, { variant: "body2", color: "textSecondary", children: event.date.toShortString() }) })] }), showConnector && _jsx(TimelineConnector, {})] }), _jsx(TimelineContent, { children: _jsx(TimelineEventCard, { event: event, isExpanded: isSelected, onToggle: toggleSelection }) })] }));
}
//# sourceMappingURL=TimelineEventItem.js.map